export default "__VITE_ASSET__d8DuK08kuh$bOhr0YBGtcw__";